import { GridController, gridTpl } from '../../../../../common/grid/grid.controller';
import * as Actions from '../adm-accounts-clients.actions'
import { IDS } from '../adm-accounts-clients-action-id.constants';

class AdmAccountsClientExternalRolesGridController extends GridController {
    /* @ngInject */
    constructor($ngRedux, $state, NavigationService, $filter, $mdDialog) {
        super($ngRedux, $state, NavigationService, $filter, $mdDialog);
    }

    $onInit() {
        this.module = 'administration';
        this.identifier = IDS.admAccountsClients;
        this.statePath = IDS.admAccountsClientExternalRolesGrid;
        this.filterOpen = true;
        this.filterExpandButtonVisible = false;
        this.exportComponent = false;
        this.confirmDialogOnRemove = true;

        this.icon = false;

        this.columns = [
            {title: '#',            mapper: null},
            {title: 'Role',         mapper: 'sty_name'},
            {title: 'Job Title',    mapper: 'external_job_title'},
            {title: 'Group ID',     mapper: 'external_uuid'},
        ];

        this.unsubscribe = this.$ngRedux.connect(
            this.mapState().bind(this), Actions)(this);

        this.dataAction = this.fetchAccountsClientExternalRoles;
        // this.exportService = this.fetchAccountsClients;
        this.filter.identifier = this.identifier;
        this.filter.statePath = this.statePath;

        this.init();
    }

    $onDestroy() {
        this.destroy();
    }
}

export const admAccountsClientExternalRolesGrid = {
    bindings: {
        title: '@',
        onSelect: '&',
        onReport: '&',
        onRemove: '&',
        onReset: '&'
    },
    controller: AdmAccountsClientExternalRolesGridController,
    ...gridTpl
};
